export default __webpack_public_path__ + "static/media/waiting-for-the-dawn.bfb8a6f4.jpg";